import "nodelist-foreach-polyfill";

const questions = document.querySelectorAll<HTMLElement>(".frequency-questions .question");

questions.forEach((el) => {
  el.addEventListener("click", () => {
    const parentList = el.parentElement;
    parentList?.classList.toggle("active");
  });
});
